module.exports = __webpack_public_path__ + "static/img/pc_2.8b21863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pc_2.png
// module id = 5okQ
// module chunks = 0